const email = (value) => {
  const reg = /^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/;
  return reg.test(value);
};
export default email;
